import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
// import Box from "@material-ui/core/Box";
// import logo_color from "./assets/logo_color.svg"
// import Button from '@material-ui/core/Button';

// var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
// var variablepadding = "15";
// if (isMobile) { var variablepadding = "1"; }

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0, 10),
    // display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: theme.palette.background.paper,
  },
  headerAbout: {
    paddingTop: "50px",
    color: "#BE2E3B",
    align: "left",
    fontWeightLight: 200,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    useNextVariants: true,
    h1: {
      fontSize: "1.25rem",
      fontWeight: "bold",
      lineHeight: "1.2em",
    },
    h2: {
      fontSize: "1.75rem",
      fontWeight: "normal",
      lineHeight: "1.2em",
    },
  },
  bio: {
    marginTop: "20px",
    fontWeight: "bold",
  },
  headerGeneral: {
    paddingTop: "0px",
    paddingBottom: "24px",
    color: "#BE2E3B",
    align: "left",
    variant: "h3",
    //component: 'h3'??
  },
  body: {
    color: "black",
    aligh: "left",
    paragraph: "true",
    variant: "body1",
  },
  linkBack: {
    paddingTop: "15px",
    color: "red",
    aligh: "left",
    paragraph: "true",
    variant: "body1",
  },
  bioH2: {
    fontStyle: "italic",
  },
}));

export default function About() {
  const classes = useStyles();

  return (
    <box>
      <div>
        <Paper
          className={classes.root}
          style={{ padding: "10% auto", height: "auto" }}
        >
          <Typography variant="h4" className={classes.headerAbout}>
          TeachAids AI Content Disclosure
          </Typography>
          <Typography variant="h5" className={classes.headerGeneral}>Last updated: June 2026</Typography>
          <Typography className={classes.body}>CoviDB.org aggregates COVID-19 and public health news from expert-vetted sources around the world. To help users quickly scan a high volume of articles, we use artificial intelligence to generate brief summaries of the original source content. Article summaries on CoviDB.org are generated automatically using AI large language model technology, which reads the original article and produces a condensed version intended to capture the key points. 
</Typography>
          <br />
          <Typography className={classes.body}>This process is fully automated. Summaries are not reviewed or edited by a human editor before publication. AI-generated summaries may misinterpret, omit, or misrepresent facts from the original article, lack important context that appears in the full article, and become outdated as the underlying news evolves. CoviDB.org does not guarantee the accuracy, completeness, or timeliness of any AI-generated summary, and you should not rely on any AI-generated summary. 
</Typography>
    <br />
          <Typography className={classes.body}>We strongly encourage all users to read the original source before citing, sharing, or acting on any article summary and verify medical or scientific claims against peer-reviewed sources. Information on CoviDB.org is not intended as medical advice or for diagnosis or treatment recommendations. The summaries are provided for informational purposes only. Always consult a qualified healthcare professional for guidance on health-related decisions.
</Typography>
          <Typography variant="h5" className={classes.headerGeneral}>
            &nbsp;
          </Typography>
        </Paper>
      </div>
    </box>
  );
}
